import actions from 'actions'
import { connect } from 'react-redux'

import { boxSummaryDeliveryDaysLoad } from 'actions/boxSummary'
import { applyPromoCode } from 'actions/home'
import { Menu } from 'routes/Menu/Menu'
import { getPromoCode } from 'selectors/basket'

import { menuCalculateTimeToUsable } from './actions/menuCalculateTimeToUsable'
import { fetchData } from './fetchData'

function mapStateToProps(state, ownProps) {
  const query = ownProps.location && ownProps.location.query
  const showOverlay = state.boxSummaryShow.get('show') || state.menuBrowseCTAShow

  return {
    showOverlay,
    boxSummaryDeliveryDays: state.boxSummaryDeliveryDays,
    query: query || {},
    params: ownProps.params,
    isAuthenticated: state.auth.get('isAuthenticated'),
    postcode: state.basket.get('postcode'),
    hasBasketPromo: Boolean(getPromoCode(state)),
    hasMenuError: Boolean(state.error.get('MENU_FETCH_DATA')),
  }
}

const mapDispatchToProps = {
  loginVisibilityChange: actions.loginVisibilityChange,
  setBasketNumPortion: actions.setBasketNumPortion,
  boxSummaryDeliveryDaysLoad,
  menuCalculateTimeToUsable,
  fetchData,
  applyPromoCode,
}

const MenuContainer = connect(mapStateToProps, mapDispatchToProps)(Menu)

export { MenuContainer }
